/**
 * Centralized file upload configuration for dropzone components
 * Used across the application for consistent file upload behavior
 */

import type { Accept } from "react-dropzone";

/**
 * Maximum file size for uploads: 2GB
 */
export const MAX_FILE_SIZE = 2 * 1024 * 1024 * 1024; // 2GB

/**
 * Maximum file size display string for UI
 */
export const MAX_FILE_SIZE_DISPLAY = "2gb";

/**
 * Accepted file types for dropzone uploads
 * Format follows react-dropzone requirements: MIME type with array of extensions
 */
export const ACCEPTED_FILE_TYPES: Accept = {
    // Images
    "image/jpeg": [".jpg", ".jpeg"],
    "image/png": [".png"],
    "image/gif": [".gif"],
    "image/webp": [".webp"],
    "image/bmp": [".bmp"],
    "image/svg+xml": [".svg"],
    // Documents
    "application/pdf": [".pdf"],
    "application/msword": [".doc"],
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"],
    "application/vnd.ms-excel": [".xls"],
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
    "text/plain": [".txt"],
    "text/csv": [".csv"],
    // Video
    "video/mp4": [".mp4"],
    "video/mpeg": [".mpeg", ".mpg"],
    "video/quicktime": [".mov"],
    "video/x-msvideo": [".avi"],
    "video/x-matroska": [".mkv"],
    "video/webm": [".webm"],
    // Audio
    "audio/mpeg": [".mp3"],
    "audio/wav": [".wav"],
    "audio/x-wav": [".wav"],
    "audio/mp4": [".m4a"],
    "audio/aac": [".aac"],
    "audio/ogg": [".ogg"],
    "audio/webm": [".webm"],
    "audio/flac": [".flac"],
};

/**
 * Multipart upload threshold: files larger than this will use multipart upload
 */
export const MULTIPART_UPLOAD_THRESHOLD = 100 * 1024 * 1024; // 100MB

/**
 * Chunk size for multipart uploads
 */
export const MULTIPART_CHUNK_SIZE = 10 * 1024 * 1024; // 10MB
